import React__default from 'react';
import c from 'classnames';
import Loader from '../../Loader/Loader.js';
import { minWidth150, largeIconStyles, minWidth120, smallMediumIconStyles, minWidth90, resetIconMargin, height56, paddingY15, minWidth180, minWidth72, width56, blurBackground, focusStylesInteractive03, focusStylesInteractive01, ghostFocusStylesInteractive03, ghostFocusStylesInteractive01, borderRadius8, alignmentExtreme } from './styles.js';

var BUTTON_SIZE_CLASSES = {
  large: c('h-48', minWidth150, largeIconStyles),
  medium: c('h-40', minWidth120, smallMediumIconStyles),
  small: c('h-36', minWidth90, smallMediumIconStyles, resetIconMargin),
  'x-large': c(height56, paddingY15, minWidth180, largeIconStyles),
  'x-small': c('h-32', minWidth72, smallMediumIconStyles)
};
var ICONBUTTON_SIZE = {
  large: c('h-48 w-48', largeIconStyles),
  medium: c('h-40 w-40', smallMediumIconStyles),
  small: c('w-36 h-36', smallMediumIconStyles),
  'x-large': c(height56, width56, largeIconStyles),
  'x-small': c('w-32 h-32', smallMediumIconStyles)
};
var BORDER_RADIUS = {
  pill: 'rounded-full',
  square: borderRadius8,
  theme: 'rounded-24'
};
var TYPOGRAPHY_CLASSES = {
  large: 'heading-xs',
  medium: 'heading-xxs',
  small: 'heading-xxs',
  'x-large': 'heading-s',
  'x-small': 'heading-xxs'
};
var COMMON_OUTLINE_CLASSES = 'border border-solid hover:bg-transparent';
var COLOR_CLASSES = {
  filled: {
    blur: c('bg-interactive-blur hover:bg-interactive-blur-hover active:bg-interactive-blur-hover disabled:opacity-60', blurBackground, focusStylesInteractive03),
    danger: c('bg-bg-error hover:bg-error-hover active:bg-error-active disabled:opacity-50', focusStylesInteractive01),
    inverse: c('bg-interactive-white hover:bg-interactive-white-hover active:bg-interactive-white-active disabled:opacity-50', focusStylesInteractive03),
    primary: c('bg-interactive-primary hover:bg-interactive-primary-hover active:bg-interactive-primary-active disabled:opacity-50', focusStylesInteractive01),
    secondary: c('bg-interactive-secondary hover:bg-interactive-secondary-hover active:bg-interactive-secondary-active disabled:opacity-50', focusStylesInteractive01)
  },
  ghost: {
    blur: ghostFocusStylesInteractive03,
    danger: c(ghostFocusStylesInteractive01, 'hover:bg-bg-error-light active:bg-border-error disabled:opacity-60'),
    inverse: c(ghostFocusStylesInteractive03, 'hover:bg-interactive-blur-hover active:bg-interactive-blue disabled:opacity-60'),
    primary: c(ghostFocusStylesInteractive01, 'hover:bg-interactive-secondary active:bg-interactive-secondary-hover disabled:opacity-50'),
    secondary: c(ghostFocusStylesInteractive01, 'hover:bg-interactive-bg-hover active:bg-interactive-bg-active disabled:opacity-60')
  },
  outlined: {
    blur: focusStylesInteractive03,
    danger: c(COMMON_OUTLINE_CLASSES, focusStylesInteractive01, 'border-border-error hover:border-border-error-dark active:bg-border-error active:border-border-error-dark disabled:opacity-60'),
    inverse: c(COMMON_OUTLINE_CLASSES, focusStylesInteractive03, 'border-interactive-white hover:border-interactive-white-hover hover:bg-interactive-blur-hover active:bg-interactive-blur active:border-interactive-white-active disabled:opacity-60'),
    primary: c(COMMON_OUTLINE_CLASSES, focusStylesInteractive01, 'border-interactive-primary hover:border-interactive-primary-hover active:bg-interactive-secondary active:border-interactive-primary-active disabled:opacity-50'),
    secondary: c(COMMON_OUTLINE_CLASSES, focusStylesInteractive01, 'border-interactive-border hover:border-border-dark active:bg-interactive-bg-hover active:border-border-dark disabled:opacity-60')
  }
};
var TEXT_COLOR_CLASSES = {
  filled: {
    blur: c('text-interactive-white disabled:text-interactive-white active:text-interactive-white-active', blurBackground, focusStylesInteractive03),
    danger: c('text-interactive-white disabled:text-interactive-white', focusStylesInteractive01),
    inverse: c('text-interactive-primary disabled:text-interactive-primary', focusStylesInteractive03),
    primary: c('text-interactive-white disabled:text-interactive-white', focusStylesInteractive01),
    secondary: c('text-interactive-primary disabled:text-interactive-primary', focusStylesInteractive01)
  },
  ghost: {
    blur: ghostFocusStylesInteractive03,
    danger: c(ghostFocusStylesInteractive01, 'text-text-error active:text-text-error disabled:text-text-error'),
    inverse: c(ghostFocusStylesInteractive03, 'text-interactive-white active:text-interactive-white disabled:text-interactive-white'),
    primary: c(ghostFocusStylesInteractive01, 'text-interactive-primary disabled:text-interactive-primary hover:text-interactive-primary-hover active:text-interactive-primary-active'),
    secondary: c(ghostFocusStylesInteractive01, 'text-link-internal disabled:text-link-internal hover:text-link-internal-hover active:text-link-internal-active')
  },
  outlined: {
    blur: focusStylesInteractive03,
    danger: c(COMMON_OUTLINE_CLASSES, focusStylesInteractive01, 'text-text-error active:text-text-error disabled:text-text-error'),
    inverse: c(COMMON_OUTLINE_CLASSES, focusStylesInteractive03, 'text-interactive-white active:text-interactive-white disabled:text-interactive-white'),
    primary: c(COMMON_OUTLINE_CLASSES, focusStylesInteractive01, 'text-interactive-primary disabled:text-interactive-primary active:text-interactive-primary-active hover:text-interactive-primary-hover '),
    secondary: c(COMMON_OUTLINE_CLASSES, focusStylesInteractive01, 'text-interactive-text disabled:text-interactive-text hover:text-interactive-text-hover active:text-interactive-text-active')
  }
};
var PADDING_X = {
  large: {
    pill: 'px-20',
    square: 'px-20',
    theme: 'px-20'
  },
  medium: {
    pill: 'px-20',
    square: 'px-20',
    theme: 'px-20'
  },
  small: {
    pill: 'px-16',
    square: 'px-16',
    theme: 'px-16'
  },
  'x-large': {
    pill: 'px-24',
    square: 'px-24',
    theme: 'px-24'
  },
  'x-small': {
    pill: 'px-16',
    square: 'px-16',
    theme: 'px-16'
  }
};
var ALIGNMENT_CLASSES = {
  center: 'items-center',
  extreme: alignmentExtreme,
  left: 'justify-start',
  right: 'justify-end'
};
var LOADER_COLOR_CLASSES = {
  filled: {
    blur: {
      arc: 'interactive-white',
      circle: 'interactive-white-active'
    },
    danger: {
      arc: 'interactive-white',
      circle: 'border-error-dark'
    },
    inverse: {
      arc: 'interactive-primary',
      circle: 'interactive-border'
    },
    primary: {
      arc: 'interactive-white',
      circle: 'interactive-primary-active'
    },
    secondary: {
      arc: 'interactive-primary',
      circle: 'interactive-border'
    }
  },
  ghost: {
    blur: {
      arc: undefined,
      circle: undefined
    },
    danger: {
      arc: 'error',
      circle: 'border-error'
    },
    inverse: {
      arc: 'interactive-white',
      circle: 'interactive-primary-active'
    },
    primary: {
      arc: 'interactive-primary',
      circle: 'interactive-border'
    },
    secondary: {
      arc: 'interactive-primary',
      circle: 'interactive-border'
    }
  },
  outlined: {
    blur: {
      arc: undefined,
      circle: undefined
    },
    danger: {
      arc: 'error',
      circle: 'border-error'
    },
    inverse: {
      arc: 'interactive-white',
      circle: 'interactive-primary-active'
    },
    primary: {
      arc: 'interactive-primary',
      circle: 'interactive-border'
    },
    secondary: {
      arc: 'interactive-primary',
      circle: 'interactive-border'
    }
  }
};
var getIcons = function getIcons(params) {
  var appearance = params.appearance,
    endIcon = params.endIcon,
    loading = params.loading,
    startIcon = params.startIcon,
    variant = params.variant;
  var _LOADER_COLOR_CLASSES = LOADER_COLOR_CLASSES[variant][appearance],
    arc = _LOADER_COLOR_CLASSES.arc,
    circle = _LOADER_COLOR_CLASSES.circle;
  if (!loading) {
    return {
      endIcon: endIcon,
      startIcon: startIcon
    };
  }
  if (endIcon) {
    return {
      endIcon: /*#__PURE__*/React__default.createElement(Loader, {
        arcColorToken: arc,
        circleColorToken: circle
      }),
      startIcon: startIcon
    };
  }
  return {
    endIcon: endIcon,
    startIcon: /*#__PURE__*/React__default.createElement(Loader, {
      arcColorToken: arc,
      circleColorToken: circle
    })
  };
};

export { ALIGNMENT_CLASSES, BORDER_RADIUS, BUTTON_SIZE_CLASSES, COLOR_CLASSES, ICONBUTTON_SIZE, LOADER_COLOR_CLASSES, PADDING_X, TEXT_COLOR_CLASSES, TYPOGRAPHY_CLASSES, getIcons };
//# sourceMappingURL=utils.js.map
